import React from "react";
export const LayoutItemFactory = (widget, widgetAmount, screenWidth, screenHeight, options) => {
    var _a, _b, _c, _d;
    return ({
        id: Math.random().toString(36),
        x: "0%",
        y: "0%",
        z: widgetAmount,
        unit: "%",
        width: (_a = widget.width) !== null && _a !== void 0 ? _a : "25%",
        height: (_b = widget.height) !== null && _b !== void 0 ? _b : "25%",
        name: (_c = options === null || options === void 0 ? void 0 : options.layoutItemName) !== null && _c !== void 0 ? _c : widget.name,
        widgetName: widget.name,
        widget: (_d = options === null || options === void 0 ? void 0 : options.data) !== null && _d !== void 0 ? _d : widget.factory({ screenHeight, screenWidth }),
    });
};
//Context and Provider
export const StudioContext = React.createContext({
    screenHeight: 0,
    screenWidth: 0,
    widgets: [],
    loadedFonts: [],
    setScreenHeight: (height) => { },
    setScreenWidth: (width) => { },
    layoutItems: [],
    selectedLayoutItemId: null,
    isLocked: false,
    pageList: [],
    animationsModalOpened: false,
    setAnimationsModalOpened: () => { },
    showAnimations: false,
});
export const StudioContextProvider = ({ layoutItems, selectedLayoutItemId, pageList, widgets, children, screenWidth, screenHeight, isLocked, loadedFonts, onUpdateScreenWidth, onUpdateScreenHeight, showAnimations, initialAnimationsModalOpened = false, }) => {
    const [animationsModalOpened, setAnimationsModalOpened] = React.useState(initialAnimationsModalOpened);
    const value = {
        screenHeight: screenHeight,
        screenWidth: screenWidth,
        setScreenWidth: onUpdateScreenWidth,
        setScreenHeight: onUpdateScreenHeight,
        layoutItems,
        selectedLayoutItemId,
        widgets: widgets,
        loadedFonts: loadedFonts,
        pageList,
        isLocked,
        animationsModalOpened,
        setAnimationsModalOpened,
        showAnimations,
    };
    return (React.createElement(StudioContext.Provider, { value: value }, children));
};
